module.exports = __webpack_public_path__ + "static/media/mars.34dc5ab6.jpg";